import { drypApi } from "@/services/drypApi";

interface AddNoteRequest {
	structureId: Dryp.StructureId;
	description?: string;
	file?: File;
}

export const note = {
	getAll: async (structureId: Dryp.StructureId): Promise<Dryp.Note[]> => {
		return drypApi.get<Dryp.Note[]>(`/PointNotes/GetPointNoteEntries/point/${structureId}`);
	},

	getNoteMediaFile: async (noteId: Dryp.NoteId, signal?: AbortSignal): Promise<Blob> =>
		drypApi.get<Blob>(`/PointMedia/GetPointMediaFile/pointMedia/${noteId}`, {
			responseType: "blob" as const,
			signal,
		}),

	deleteNote: async (noteId: Dryp.NoteId): Promise<void> => {
		return drypApi.delete<void>(`/PointNotes/DeletePointNote/${noteId}`);
	},

	addNote: async (request: AddNoteRequest): Promise<Dryp.Note> => {
		const { structureId, description, file } = request;

		const form = new FormData();
		if (description) form.append("description", description);
		if (file) form.append("file", file);

		return drypApi.post(`/PointNotes/UploadPointMedia/point/${structureId}`, form, {
			headers: { "Content-Type": "multipart/form-data" },
		});
	},
};
